<template>
  <div class="px-3 pb-2 mt-4 max-h-full h-full flex justify-center">This item has no configuration.</div>
</template>

<script>
export default {
  name: 'ParallelConfig',
};
</script>
